/**
 * Conversion tracking utility — pushes events to dataLayer (GA4/GTM-ready).
 * Falls back to console.log in dev if dataLayer is not available.
 */

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

interface TrackingParams {
  event: string;
  page_path: string;
  page_title: string;
  cta_location: string;
  service_context?: string;
}

export function trackEvent(params: TrackingParams) {
  const data = {
    ...params,
    ...getUtmParams(),
  };

  if (window.dataLayer) {
    window.dataLayer.push(data);
  }

  if (import.meta.env.DEV) {
    console.log("[CRO Track]", data);
  }
}

/** Extract UTM params from current URL */
function getUtmParams(): Record<string, string> {
  const params = new URLSearchParams(window.location.search);
  const utms: Record<string, string> = {};
  for (const key of ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"]) {
    const val = params.get(key);
    if (val) utms[key] = val;
  }
  return utms;
}

/** Fire Google Ads conversion event for WhatsApp contact (Brasília only) */
export function trackGoogleAdsWhatsAppConversion(isRio: boolean) {
  if (isRio) return;
  if (typeof window !== "undefined" && typeof (window as { gtag?: Function }).gtag === "function") {
    (window as { gtag?: Function }).gtag!("event", "conversion", {
      send_to: "AW-11323565082/19tqCNK_7_obEJrIv5cq",
    });
  }
}

/** Build WhatsApp URL with contextual message and origin tracking */
export function buildWhatsAppUrl(origin?: string): string {
  const originParam = origin || window.location.pathname;
  const isServicePage = /\/(dedetizacao|desratizacao|descupinizacao|sanitizacao|formigas|pulgas|aranhas|pombos|caixa-dagua|caixa-gordura|fog|anti-tracas)/.test(originParam);
  const serviceMsg = isServicePage
    ? "Olá, vim do site e gostaria de um orçamento gratuito de dedetização! (origem=" + originParam + ")"
    : "Olá, vim do site e gostaria de um orçamento gratuito! (origem=" + originParam + ")";
  const msg = encodeURIComponent(serviceMsg);
  return `https://wa.me/5561992938591?text=${msg}`;
}
